/**
 *
 * @param message
 * @returns {{html: string, customClass: {popup: string}, allowOutsideClick: boolean, allowEscapeKey: boolean, showConfirmButton: boolean}}
 */
const excelExportLoadingOptions = (message) => ({
    html: `
<style>
.excel-export-popup { padding: 2rem 1.5rem !important; }
.excel-export-popup .swal2-html-container, .excel-export-popup #swal2-content { margin: 0 !important; padding: 0 !important; }
.excel-morph-stage { display: flex; justify-content: center; margin: 0 0 16px; perspective: 420px; }
.excel-morph { position: relative; width: 84px; height: 84px; transform-style: preserve-3d; animation: excelMorphFlip 2.6s cubic-bezier(.45, 0, .25, 1) infinite; }
.excel-morph .morph-face { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; border-radius: 18px; backface-visibility: hidden; -webkit-backface-visibility: hidden; }
.excel-morph .morph-video { background: rgba(0, 158, 247, .1); }
.excel-morph .morph-excel { background: rgba(80, 205, 137, .12); transform: rotateY(180deg); }
.excel-morph-text { font-size: 1.1rem; font-weight: 500; color: #3f4254; }
@keyframes excelMorphFlip {
    0%, 35% { transform: rotateY(0deg); }
    50%, 85% { transform: rotateY(180deg); }
    100% { transform: rotateY(360deg); }
}
</style>
<div class="excel-morph-stage">
    <div class="excel-morph">
        <span class="morph-face morph-video">
            <svg width="42" height="42" viewBox="0 0 16 16" fill="#009ef7" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"/>
            </svg>
        </span>
        <span class="morph-face morph-excel">
            <svg width="42" height="42" viewBox="0 0 16 16" fill="#50cd89" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
            </svg>
        </span>
    </div>
</div>
<div class="excel-morph-text">${message}</div>
`,
    customClass: {
        popup: 'excel-export-popup'
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false
});

/**
 * Compact alert dialog for the export flow: icon, title and text live in
 * one block with controlled spacing (the theme's default swal layout leaves
 * oversized gaps between them).
 *
 * @param {string} icon
 * @param {string} title
 * @param {string} text
 * @param {string} closeText
 * @returns {object}
 */
export const excelExportAlertOptions = (icon, title, text, closeText) => {
    const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

    return {
        icon: icon,
        html: `
<style>
.excel-alert-popup .swal2-icon { margin: .25rem auto .9rem !important; }
.excel-alert-popup .swal2-content, .excel-alert-popup .swal2-html-container { margin-top: 0 !important; }
.excel-alert-popup .swal2-actions { margin: 1.2rem auto .25rem !important; }
.excel-alert-popup .excel-alert-title { font-size: 1.3rem; font-weight: 500; color: #181c32; margin-bottom: .6rem; }
.excel-alert-popup .excel-alert-text { font-size: 1.02rem; color: #7e8299; }
</style>
<div class="excel-alert-title">${esc(title)}</div>
<div class="excel-alert-text">${esc(text)}</div>
`,
        customClass: {
            popup: 'excel-alert-popup'
        },
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: closeText
    };
};

/**
 *
 * @returns {string}
 */
export const excelExportFallbackName = () => ((window.crypto && crypto.randomUUID)
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    })) + '.xlsx';

export default excelExportLoadingOptions;
